export function improvedDate(datsStr){
  // 时间戳转化为合理时间
  let dateObj = typeof datsStr === 'object' ? datsStr : new Date(datsStr)
  let time = dateObj.getTime()
  let now = Date.now()
  let space = now - time
  let str = ''
  switch (true){
    case space < 60000:
      str = '刚刚'
      break
    case space < 3600000:
      str = Math.floor(space/60000) + '分钟前'
      break
    case space < 3600000*24:
      str = Math.floor(space/(1000*3600)) + '小时前'
      break
    case space < 3600000*24*30:
      str = Math.floor(space / (1000*3600*24)) + '天前'
      break
    case space < 3600000*24*30*12:
      str = Math.floor(space / (1000*3600*24*30)) + '个月前'
      break
    default:
      str = Math.floor(space/(1000*3600*24*30*12)) + '年前'
  }
  return str
}



// WEBPACK FOOTER //
// ./src/helpers/util.js